import { RootState } from '../store/rootReducer';

export const getError = (state: RootState): string | null => state.global.error;
export const getSuccess = (state: RootState): string | null => state.global.success;
export const isLoading = (state: RootState): boolean => state.global.loading;
